<template>
  <div id="app">
    <expired
      v-if="isLogged && $user.user && !$user.user.is_enable && !isShortCourse"
    />

    <component v-else :is="template">
      <router-view :key="$route.fullPath" />
    </component>

    <snackbar />
  </div>
</template>

<script>
import { getToken } from "./setup/api";
import Expired from "@/components/Expired";

export default {
  components: { Expired },
  computed: {
    template() {
      return this.$route.meta.template;
    },
    isLogged() {
      return this.$store.state.user.logged;
    },
    showRouterView() {
      return !this.$route.meta.protected || this.isLogged;
    },
    isShortCourse() {
      return this.$route.name === "short-course";
    }
  },
  beforeMount() {
    if (!getToken() && this.$route.meta.protected) {
      this.$router.replace({ name: "login" });
    } else if (getToken()) {
      if (["/login", "/register"].includes(document.location.pathname)) {
        this.$router.replace({ name: "home" });
      }
    }
  },
  watch: {
    "$route.path": function() {
      if (!this.isLogged && this.$route.meta.protected) {
        this.$router.replace({ name: "login" });
      }
      window.scrollTo(0, 0);
    }
  }
};
</script>
